export const acceptedFileMimeType = [
    "application/pdf",
    'image/png',
    'image/jpeg'
];